export default __webpack_public_path__ + "static/media/0027.2fe6c56d.WAV";